<template>
  <!-- ラベルシート表示 -->
  <div id="HolterLabel12SheetView">
    <div id="container">
      <div class="labelTitle lable">ラベルシート表示</div>
      <div class="button-area">
        <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy">クリップボードにコピー</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div class="result-area">
        <table id="clipTable">
          <tr v-for="(item, index) in label12SheetData" :key="index">
            <td><span v-if="item.name1!=''">{{item.name1}}　様</span></td>
            <td v-if="item.name2"><span v-if="item.name2!=''">{{item.name2}}　様</span></td>
          </tr>
        </table>
    　</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HolterLabel12SheetView",
  methods: {
    back: function () {
      this.$router.push({
        name: "HolterShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    clipboardCopy: function() {
      var clipTable = document.getElementById('clipTable');
      navigator.clipboard.writeText(clipTable.innerText).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    }
  },
  data() {
    var data = this.$route.params["data"];
    var label12SheetData = []
    for(var i=0; i < data.length; i=i+2){
      var item = {
        name1:data[i],
        name2:data[i+1] ? data[i+1] : ""
      }
      label12SheetData.push(item)
    }
    var searchParams = this.$route.params["searchConditions"];
    return {
      label12SheetData,
      searchParams,
    };
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holter/shipping/HolterLabel12SheetView.vue